




import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';

// Why, Typescript, Why?
// @ts-ignore
import Panolens from '../lib/panolens/panolens.js';

@Component
export default class Pano extends Vue {
    @Prop({ default: '' }) public source: string;

    public viewer;
    public panorama;
    private size;

    public created() {
        window.addEventListener('resize', this.onResize, false);
    }

    public destroyed() {
        if (this.panorama.dispose) {
            this.panorama.dispose();
        }
    }

    public mounted() {
        this.size = {
            width: (this.$el as any).offsetWidth,
            height: (this.$el as any).offsetHeight,
        };
        this.viewer = new Panolens.Viewer({
            container: this.$el,
            controlButtons: [],
        });
        this.loadPano();
    }

    public onResize() {
        this.$nextTick(() => {
            this.size = {
                width: (this.$el as any).offsetWidth,
                height: (this.$el as any).offsetHeight,
            };
        });
    }

    public loadPano() {
        if (!this.source) {
            return;
        }
        this.panorama = new Panolens.ImagePanorama(this.source);
        this.viewer.add(this.panorama);
        this.panorama.addEventListener('load', () => {
            this.viewer.enableControl(1);
            this.$emit('on-load');
        });
    }
}
